<template>
  <div class="dataTables_wrapper form-inline dt-bootstrap" id="example1_wrapper">
    <div class="row">
      <div class="col-sm-6 text-left">
        <div class="form-group text-left">
          <router-link :to="{
            name: 'crAd',
            params: {
              brand_id: $route.params.brand_id,
              store_id: $route.params.store_id,
            },
            query: {
              new: true,
              tab: 12,
            },
          }">
            <div class="btn btn-default btn-table-title"><i class="fa fa-plus" aria-hidden="true"></i> 新增橫幅廣告</div>
          </router-link>
          <router-link :to="{
            name: 'crAd',
            params: {
              brand_id: $route.params.brand_id,
              store_id: $route.params.store_id,
            },
            query: {
              new: true,
              tab: 41,
            },
          }">
            <div class="btn btn-default btn-table-title"><i class="fa fa-plus" aria-hidden="true"></i> 新增蓋版廣告</div>
          </router-link>
        </div>
        <div class="form-group text-left" v-if="getRoleType !== 10">
          <router-link :to="{
            name: 'copyAd',
            params: {
              brand_id: $route.params.brand_id,
              store_id: $route.params.store_id,
            },
            query: {
              tab: 12,
            },
          }">
            <div class="btn btn-default btn-table-title">複製橫幅廣告</div>
          </router-link>
        </div>
        <div class="form-group text-left" v-if="getRoleType !== 10">
          <router-link :to="{
            name: 'copyAd',
            params: {
              brand_id: $route.params.brand_id,
              store_id: $route.params.store_id,
            },
            query: {
              tab: 41,
            },
          }">
            <div class="btn btn-default btn-table-title">複製蓋板廣告</div>
          </router-link>
        </div>
        <div class="form-group">
          <select class="form-control h-38" v-model="selectActive">
            <option value="99">全部</option>
            <option value="1">啟用</option>
            <option value="0">停用</option>
          </select>
        </div>
      </div>
      <!-- 41:蓋版廣告不提供排序 & 地區設定 -->
      <div
        v-if="bannerType !== 41"
        class="col-sm-6 text-right"
      >
        <div class="form-group">
          <select v-model="searchType" class="form-control h-38">
            <option :value="1">名稱</option>
            <option :value="2">地區</option>
          </select>
        </div>
        <div class="form-group search-bar">
          <div v-if="searchType === 1" class="input-group">
            <input class="form-control" type="text" v-model="searchInput">
            <span class="input-group-addon c-pointer" @click="getAdList()"><i class="fa fa-search"></i></span>
          </div>
          <div v-else class="input-group">
            <multiselect
              class="min-w-150"
              v-model="selectCity"
              :options="cityOption"
              :searchable="true"
              :allow-empty="true"
              :close-on-select="false"
              :show-labels="false"
              placeholder=""
              :multiple="true"
              label="name"
              track-by="code"
            />
            <span class="input-group-addon c-pointer" @click="getAdList()"><i class="fa fa-search"></i></span>
          </div>
        </div>
      </div>
      <!-- End 41:蓋版廣告不提供排序 & 地區設定 -->
    </div>
    <div class="row">
      <div class="col-xs-12 tab">
        <ul class="nav nav-tabs" style="margin-bottom: 10px;">
          <li role="presentation" :class="{active: bannerType === 12}">
            <a @click.prevent="changeBannerType(12)">橫幅廣告
            </a>
          </li>
          <li role="presentation" :class="{active: bannerType === 41}">
            <a @click.prevent="changeBannerType(41)">蓋版廣告
            </a>
          </li>
        </ul>
      </div>
      <div class="col-xs-12 my-10">
        <span>
          <button @click="startDrag" class="btn btn-default drag-btn">
            <img src="../../../../assets/icon/i-sort.svg" class="sort-icon" />
          廣告排序</button>
        </span>
        <span>
          <button class="btn btn-default col" @click="startBatchDelete"><i class="fa fa-minus" aria-hidden="true"></i> 批次刪除</button>
        </span>
        <span>
          <router-link :to="{
            name: 'storeGroup',
            params: {
              brand_id: $route.params.brand_id
            }
          }">
            <div class="btn btn-default btn-table-title padding-6">門市群組</div>
          </router-link>
        </span>
      </div>
      <div class="col-xs-12 my-10 row">
        <div class="col-sm-6">
          <div v-if="isDraggable" class="message-info">
            <span class="text-danger">＊ </span>
            可對前20則狀態為啟用的廣告圖片進行排序。<br>
            <span class="text-danger">＊ </span>
            完成排序並儲存後，請重新整理前台頁面，即可看到廣告排序已變更為最新設定。
          </div>
          <div v-if="isBatchDelete" class="message-info">
            <span class="text-danger">＊ </span>
            可對廣告圖片進行批次刪除。<br>
            <span class="text-danger">＊ </span>
            刪除後不可復原。
          </div>
        </div>
        <div class="col-sm-6 text-right">
          <button v-if="isDraggable" @click="stopDrag(false)" class="btn btn-default btn-secondary">取消</button>
          <button v-if="isDraggable" @click="stopDrag(true)" class="btn btn-default label-success">儲存</button>
          <button v-if="isBatchDelete" @click="BatchDelete(false)" class="btn btn-default btn-secondary">取消</button>
          <button v-if="isBatchDelete" @click="BatchDelete(true)" class="btn btn-default label-danger">刪除</button>
        </div>
      </div>
      <div class="col-sm-12 table-responsive p-x-0">
        <table aria-describedby="example1_info" role="grid" id="example1" class="table table-bordered table-striped dataTable">
          <thead>
          <tr role="row">
            <th v-show="isDraggable" colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">排序</th>
            <th v-show="isBatchDelete" colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class=""></th>
            <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">#</th>
            <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">圖片與連結</th>
            <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">名稱 (ID)</th>
            <th v-if="bannerType !== 41" colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">廣告地區</th>
            <!--only show.brand-->
            <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">廣告開始時間</th>
            <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">廣告結束時間</th>
            <!--原本只有蓋板廣告會顯示，經這次調整橫幅廣告也會顯示狀態-->
            <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">狀態</th>
            <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">更新時間</th>
            <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">你訂平台</th>
            <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">街口平台</th>
            <!--<th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">建立時間</th>-->
            <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class=""></th>
            <!-- col different-->
          </tr>
          </thead>
          <tbody v-if="isLoading">
            <tr>
              <td colspan="12" class="text-center">資料讀取中......</td>
            </tr>
          </tbody>
          <draggable v-else-if="adList.length > 0" v-model="adList" tag="tbody" handle=".handle">
          <tr class="even" role="row" v-for="(ad, index) in adList">
            <!-- cloumn 0 -->
            <td v-show="isDraggable"><i class="fa fa-bars handle"></i></td>
            <td v-show="isBatchDelete"><input type="checkbox" class="checkbox" v-model="ad.selectItem"></td>
            <td class="sorting_1">{{index + 1}}</td>
            <!-- column 1-->
            <td><a :href="ad.url" target="_blank"><img class="img-ad-table" :src="ad.image_web"></a></td>
            <!-- column 2-->
            <td>
              <span>{{ad.name}} ({{ad.id}})</span>
            </td>
            <!-- 廣告地區 (蓋板無限制地區) -->
            <td v-if="bannerType !== 41">
              <More
                :moreText="$options.filters.cityCode(ad.city_code_list)"
                title="指定區域"
                :height="46"
              />
            </td>
            <!-- column 4-->
            <td>{{ad.start_time}}</td>
            <!-- column 5-->
            <td>{{ad.end_time}}</td>
            <!-- column middle-->
            <!--原本只有蓋板廣告會顯示，經這次調整橫幅廣告也會顯示狀態-->
            <td><div :class="timeMethodColor(ad.time_method)">{{ad.time_method | status}}</div></td>
            <td>{{ad.edit_time}}</td>
            
            <td>
              <span v-if="ad.is_platform_visible" class="label label-success">啟用</span>
              <span v-if="!ad.is_platform_visible"  class="label label-danger">停用</span>
            </td>
            <td>
              <span v-if="ad.dedicated_visible_setting.indexOf(1)>-1" class="label label-success">啟用</span>
              <span v-if="ad.dedicated_visible_setting.indexOf(1)<0"  class="label label-danger">停用</span>
            </td>
            <!--<td>{{ad.create_time}}</td>-->
            <!-- column last-->
            <td>
              <router-link :to="{
                name: 'upAd',
                params: {
                  brand_id: $route.params.brand_id,
                  store_id: $route.params.store_id,
                  ad_id: ad.id,
                },
                query: {
                  tab: bannerType,
                },
              }">
                <button class="btn btn-default"><i class="fa fa-pencil" aria-hidden="true"></i></button>
              </router-link>
              <button class="btn btn-default col"><i class="fa fa-trash" aria-hidden="true" @click="deleteBanner(ad.id)"></i></button>
            </td>
          </tr>
          </draggable>
          <tbody v-else-if="adList.length === 0">
            <tr style="background-color: white">
              <td rowspan="1" colspan="12" style="text-align: center; padding-bottom: 80px; padding-top:80px;">
                <img src="/static/img/noMatchdata.svg" style="max-width: 148px;" class="center-block logo">
                <span style="margin-bottom: 80px; color: #696969;">沒有符合的資料</span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <paginate
        :pageAmount="pageAmount"
        :total="total"
        :isActive="isActive"
        :groupAmount="groupAmount"
        :clickPage="clickPage"
      />
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import draggable from 'vuedraggable'
import More from '@/components/elements/More.vue'
export default{
  components: {
    draggable,
    More
  },
  filters: {
    status: (val) => {
      switch (val) {
        case 'notyet':
          return '尚未開始'
        case 'going':
          return '進行中'
        case 'end':
          return '結束'
        default:
          return ''
      }
    }
  },
  data () {
    return {
      bannerType: Number(this.$route.query.tab) || 12,
      selectActive: 99,
      test: '指定區域：台北市、新北市、新竹市、台中市、台中市、台中市、台中市、台中市、台中市',
      show: {
        brand: false,
        menu: false,
        schedule: false,
        history: false,
        menuDetail: false
      },
      tableIndex: 1,
      pageGroup: 1,
      groupAmount: 10,
      total: 1,
      count: 10,
      adList: [],
      searchInput: '',
      isBatchDelete: false,
      isDraggable: false,
      isLoading: true,
      // 選擇地區
      searchType: 1,
      selectCity: []
    }
  },
  methods: {
    ...mapActions(['setCityList']),
    BatchDelete (type) {
      this.isBatchDelete = false
      const formData = this.adList.filter(x => x.selectItem).map(x => x.id)
      if (type && formData.length) {
        const formData = this.adList.filter(x => x.selectItem).map(x => x.id)
        var url = '/store/' + this.$route.params.store_id + '/banner/batchDelete?banner_ids=' + formData.toString()
        this.getDataH('delete', url, null, (response) => {
          if (response.data.status === 200) {
            this.$notify({
              title: '提醒',
              text: '刪除門市廣告成功',
              duration: 3000,
              type: 'success',
              width: 400
            })
            this.clickPage(1)
          }
        })
      }
    },
    startBatchDelete () {
      this.isDraggable = false
      this.isBatchDelete = true
    },
    startDrag () {
      this.isBatchDelete = false
      this.isDraggable = true
      this.tableIndex = 1
      this.getAdList()
    },
    stopDrag (val) {
      if (val) {
        this.setListOrder()
      } else {
        this.getAdList()
      }
      this.isDraggable = false
    },
    setListOrder () {
      var url = '/store/' + this.$route.params.store_id + '/banner/sortBanner'
      const data = {
        banner_id_list: this.adList.map(x => x.id)
      }
      this.getDataH('post', url, data, (response) => {
        if (response.data.status === 200) {
          this.$notify({
            title: '提醒',
            text: '編輯品牌網站廣告成功',
            duration: 3000,
            type: 'success',
            width: 400
          })
          this.getAdList()
        }
      })
    },
    timeMethodColor (val) {
      switch (val) {
        case 'notyet':
          return 'label label-default'
        case 'going':
          return 'label label-success'
        case 'end':
          return 'label label-danger'
        default:
          return ''
      }
    },
    deleteBanner (id) {
      var url = '/store/' + this.$route.params.store_id + '/banner/' + id
      this.getDataH('delete', url, null, (response) => {
        if (response.data.status === 200) {
          this.$notify({
            title: '提醒',
            text: '刪除店家廣告成功',
            duration: 3000,
            type: 'success',
            width: 400
          })
          this.clickPage(1)
        }
      })
    },
    isActive (index) {
      if (this.tableIndex === index) return true
      else return false
    },
    clickPage (index) {
      this.tableIndex = index
      this.getAdList()
    },
    changeBannerType (val) {
      this.$router.replace({query: {tab: val}})
      this.bannerType = val
      this.tableIndex = 1
      this.getAdList()
    },
    getAdList () {
      this.isLoading = true
      var self = this
      var data = {
        page: this.tableIndex,
        size: this.count
      }
      var url = '/store/' + this.$route.params.store_id + '/bannerList?page=' + data.page + '&size=' + data.size + '&banner_type=' + this.bannerType
      if (parseInt(this.selectActive, 10) !== 99) url = url + '&is_active=' + this.selectActive
      if (this.bannerType !== 41 && this.searchType === 1 && this.searchInput.trim()) {
        url = url + '&name=' + this.searchInput
      }
      if (this.bannerType !== 41 && this.searchType === 2 && this.selectCity.length) {
        const cityCode = this.selectCity.map(item => {
          return item.code
        })
        url = url + '&city_code=' + cityCode.join(',')
      }
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          self.adList = response.data.list
          self.total = response.data.list_total
          self.isLoading = false
        }
      })
    },
    pageShow (index) {
      var num = index / this.groupAmount
      if (this.pageGroup - 1 < num && num <= this.pageGroup) return true
      else return false
    }
  },
  created () {
    this.getAdList(1)
    if (!this.getCityOption.length) {
      // 取得縣市列表
      this.setCityList()
    }
  },
  computed: {
    ...mapGetters(['getRoleType', 'getCityOption']),
    getDataH () {
      return this.$parent.getDataH
    },
    pageAmount () {
      return Math.ceil(this.total / this.count)
    },
    cityOption () {
      return [
        {
          name: '不限',
          code: 999
        },
        ...this.getCityOption
      ]
    }
  },
  watch: {
    selectActive () {
      this.tableIndex = 1
      this.searchInput = ''
      this.getAdList()
    }
  }
}
</script>
<style scoped>
table.table-bordered tbody td, table.dataTable thead > tr > th {
  text-align: center;
  vertical-align: middle;
  margin: 0px;
  padding: 5px 0px;
}
.my-10 {
  margin: 10px 0px;
}
.message-info {
  width: fit-content;
  font-size: 14px;
  border: 1px solid #DEDEDE;
  border-radius: 4px;
  padding: 10px;
  text-align: left;
}
.checkbox {
  margin: 0px 10px;
}
.sort-icon{
  width: 14px;
  height: 14px;
}
.padding-6 {
  padding-top: 6px;
  padding-bottom: 6px;
}
</style>



// WEBPACK FOOTER //
// AdTableTemp.vue?6510d776